<template>
  <v-container fluid v-if="getPermission('setting:view')">
    <v-layout>
      <v-flex>
        <h3 class="font-weight-700 mb-4 font-size-24 custom-headline color-custom-blue">
          Payroll Settings
        </h3>
      </v-flex>
      <v-flex class="text-right">
        <v-btn depressed class="custom-grey-border custom-bold-button" v-on:click="goBack">
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </v-flex>
    </v-layout>
    <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shadow"
      style="position: relative">
      <v-card flat class="custom-setting-height custom-grey-border remove-border-radius">
        <v-card-title class="headline grey lighten-4">
          <v-row>
            <v-col md="6" class="py-0 my-auto">
              <h3 class="font-weight-700 custom-headline color-custom-blue" style="margin: 3.5px 0px">
                <!--  Service # -->
              </h3>
            </v-col>
            <template v-if="getPermission('setting:update')">
              <v-col md="6" class="text-right py-0">
                <v-btn depressed small class="text-white" color="cyan" v-on:click="updatepayrollSetting"
                  :disabled="pageLoading" :loading="pageLoading">
                  <span class="font-size-16 font-weight-600">Update</span>
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </v-card-title>
        <v-card-text class="p-6 font-size-16" :class="{ 'pointer-events-none': !getPermission('setting:update') }">
          <table class="width-100 font-size-14">
            <tr>
              <td class="custom-border-right custom-border-left custom-border-top py-3 custom-font-weight" width="30%">
                Basic Pay
              </td>
              <td class="custom-border-right custom-border-top py-3" width="70%">
                <v-text-field auto-grow dense type="number" filled color="cyan" v-model="payrollSetting.basic_pay"
                  prefix="$" placeholder="Basic Pay" solo row-height="4" flat></v-text-field>
              </td>
            </tr>
            <tr>
              <td class="custom-border-right custom-border-left custom-border-top py-3 custom-font-weight" width="30%">
                Housing Allowance
              </td>
              <td class=" " width="70%">
                <v-text-field auto-grow dense filled color="cyan" type="number"
                  v-model="payrollSetting.housing_allowance" placeholder="Housing Allowance" solo prefix="$"
                  row-height="4" flat></v-text-field>
              </td>
            </tr>
            <tr>
              <td class="custom-border-right custom-border-left custom-border-top py-3 custom-font-weight" width="30%">
                Transportation Allowance (Before Probation)
              </td>
              <td class="custom-border-right custom-border-top py-3" width="70%">
                <v-text-field auto-grow dense filled color="cyan" type="number"
                  v-model="payrollSetting.transport_allowance_before_pro" placeholder=" Transportation Allowance"
                  prefix="$" solo row-height="4" flat></v-text-field>
              </td>
            </tr>
            <tr>
              <td class="custom-border-right custom-border-left custom-border-top py-3 custom-font-weight" width="30%">
                Transportation Allowance (After Probation)
              </td>
              <td class="custom-border-right custom-border-top py-3" width="70%">
                <v-text-field auto-grow dense filled color="cyan" type="number"
                  v-model="payrollSetting.transport_allowance_after_pro" placeholder=" Transportation Allowance"
                  prefix="$" solo row-height="4" flat></v-text-field>
              </td>
            </tr>
            <tr>

              <td class="custom-border-right custom-border-left custom-border-top py-3 custom-font-weight" width="30%">
                Phone Allowance
              </td>
              <td class="custom-border-right custom-border-top py-3" width="70%">
                <v-text-field auto-grow dense filled color="cyan" v-model="payrollSetting.phone_allowance" type="number"
                  prefix="$" placeholder=" Phone Allowance" solo row-height="4" flat></v-text-field>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </perfect-scrollbar>
  </v-container>
</template>

<script>
import { GET, POST } from "@/core/services/store/request.module";

export default {
  name: "profile-service-setting",
  data() {
    return {
      pageLoading: false,
      visitlist: [
        {
          value: "name",
          text: "Id",
        },
        {
          value: "Title",
          text: "Title",
        },
        {
          value: "customer",
          text: "Customer",
        },
      ],
      deliverylist: [
        {
          value: "name",
          text: "Id",
        },
        {
          value: "Title",
          text: "Title",
        },
        {
          value: "customer",
          text: "Customer",
        },
      ],
      quotationlist: [
        {
          value: "name",
          text: "Id",
        },
        {
          value: "Title",
          text: "Title",
        },
        {
          value: "customer",
          text: "Customer",
        },
      ],
      contractlist: [
        {
          value: "name",
          text: "Id",
        },
        {
          value: "Title",
          text: "Title",
        },
        {
          value: "customer",
          text: "Customer",
        },
      ],
      projectlist: [
        {
          value: "name",
          text: "Id",
        },
        {
          value: "Title",
          text: "Title",
        },
        {
          value: "customer",
          text: "Customer",
        },
      ],
      leavelist: [
        {
          value: "category",
          text: "Leave Type",
        },
        {
          value: "start",
          text: "Start Date",
        },
        {
          value: "end",
          text: "End Date",
        },
        {
          value: "engineer",
          text: "User",
        },
      ],
      payrollSetting: {
        // visit: [],
        // delivery: [],
        // quotation: [],
        // contract: [],
        // project: [],
        // leave: [],
      },
      setting: {
        prefix: null,
        next_number: null,
        number_length: null,
        description: null,
      },
    };
  },
  methods: {
    getPayrollsetting() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "setting/payroll-setting-list" })
        .then(({ data }) => {
          _this.payrollSetting = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    // remove(item, type) {
    //     if (type == "visit") {
    //         if (this.payrollSetting.visit.length > 1) {
    //             const index = this.payrollSetting.visit.indexOf(item.value);
    //             this.payrollSetting.visit.splice(index, 1);
    //         }
    //         return false;
    //     } else if (type == "delivery") {
    //         if (this.payrollSetting.delivery.length > 1) {
    //             const index = this.payrollSetting.delivery.indexOf(item.value);
    //             this.payrollSetting.delivery.splice(index, 1);
    //         }
    //         return false;
    //     } else if (type == "quotation") {
    //         if (this.payrollSetting.quotation.length > 1) {
    //             const index = this.payrollSetting.quotation.indexOf(item.value);
    //             this.payrollSetting.quotation.splice(index, 1);
    //         }
    //         return false;
    //     } else if (type == "contract") {
    //         if (this.payrollSetting.contract.length > 1) {
    //             const index = this.payrollSetting.contract.indexOf(item.value);
    //             this.payrollSetting.contract.splice(index, 1);
    //         }
    //         return false;
    //     } else if (type == "project") {
    //         if (this.payrollSetting.project.length > 1) {
    //             const index = this.payrollSetting.project.indexOf(item.value);
    //             this.payrollSetting.project.splice(index, 1);
    //         }
    //         return false;
    //     } else if (type == "leave") {
    //         if (this.payrollSetting.leave.length > 1) {
    //             const index = this.payrollSetting.leave.indexOf(item.value);
    //             this.payrollSetting.leave.splice(index, 1);
    //         }
    //         return false;
    //     }
    // },
    updatepayrollSetting() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(POST, {
          url: "setting/payroll-setting",
          data: _this.payrollSetting,
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  mounted() {
    this.getPayrollsetting();
  },
};
</script>
<style lang="scss" scoped>
.custom-border-top {
  border-width: 1px;
}
</style>
